import * as yup from 'yup';
import { EMAIL_VALID, REQUIRE_VALID } from '../../data';

export interface IMemberToUser {
  email: string;
}

export const MEMBER_TO_USER_DEFAULT_VALUES = {
  email: '',
};

export const MEMBER_TO_USER_VALIDATION = yup.object({
  email: yup.string().email(EMAIL_VALID).required(REQUIRE_VALID),
});
